<template>
    <div class="screenWidth itemList pt-4">
        <!-- 麵包屑 -->
        <BreadCrumbs :breadCrumbList="breadCrumbList"
                     :gaData="gaData" />
        <div class="mb-2 mt-md-2 searchBlock__content">
            <input type="text"
                   class="form-control search__input rounded-pill pt-2"
                   placeholder="請輸入關鍵字"
                   v-model.trim="inputText" />
            <button type="button"
                    class="btn btn-sec search__btn d-inline-block rounded-pill pt-2"
                    :disabled="loading"
                    @click="getInputText(inputText)">
                搜尋
            </button>
            <div class="errorMsg">{{errorMsg}}</div>
        </div>
        <!-- 切換顯示樣式 -->
        <div class="mb-3 mb-lg-0 pt-0 row no-gutters">
            <div class="col-12">
                <Theme :titleText="'關鍵字搜尋'"
                       :font24="true"
                       class="mb-3" />
            </div>
            <div class="col-12 d-block d-md-flex justify-content-md-end">
                <label class="text-nowrap mt-n2 mt-md-1 mb-1 mb-md-0 flex flex-md-grow-1 d-block text-right text-md-left">
                    共有 {{total|commaFormat}}項結果
                </label>
                <Select class="d-md-flex justify-content-md-start mt-n4 mt-md-0"
                        :selectName="'排序依據：'"
                        :value="orderby.label"
                        :disabled="loading"
                        :selectOption="orderbyList"
                        @selectemit="setOrderby" />
                <Select class="d-md-flex justify-content-md-start"
                        :selectName="'媒體格式：'"
                        :value="type.label"
                        :disabled="loading"
                        :selectOption="typeList"
                        @selectemit="setType" />
                <!-- 切換顯示樣式 -->
                <div class="text-right listType mb-4 mt-lg-1">
                    <button type="button"
                            class="btn btn-link py-0 border-right rounded-0"
                            @click="setDisplay('card')">
                        <GridIcon v-if="display === 'card'"
                                  size="1.5x"
                                  stroke-width="2" />
                        <GridIcon v-else
                                  size="1.5x"
                                  stroke-width="2"
                                  class="lightcolor" />
                    </button>
                    <button type="button"
                            class="btn btn-link py-0 rounded-0"
                            @click="setDisplay('list')">
                        <AlignCenterIcon v-if="display === 'list'"
                                         size="1.5x"
                                         stroke-width="2" />
                        <AlignCenterIcon v-else
                                         size="1.5x"
                                         stroke-width="2"
                                         class="lightcolor" />
                    </button>
                </div>
            </div>
        </div>
        <!-- 文章資料 -->
        <ArticleDisplay :display="display"
                        :contentPage="contentPage"
                        :articleRes="articleRes"
                        :isShowOrderNum="false"
                        :loading="loading" />
        <Pagination :lastPage="lastPage"
                    :gaData="gaData"
                    :currentPage="currentPage"
                    @getPage="getPage" />
    </div>
</template>
<script>
import { post } from '@/api';
import { AlignCenterIcon, GridIcon } from 'vue-feather-icons';
import Theme from '@/components/Theme.vue';
import BreadCrumbs from '@/components/BreadCrumbs.vue';
import ArticleDisplay from './ArticleDisplay.vue';
import Select from './Select.vue';
import Pagination from '@/components/Pagination.vue';
import { debounce } from 'debounce';

export default {
    name: 'SearchArticleList',
    components: {
        Theme,
        AlignCenterIcon,
        GridIcon,
        ArticleDisplay,
        Select,
        Pagination,
        BreadCrumbs,
    },
    data() {
        return {
            loading: false,
            contentPage: '列表頁',
            list: '文章列表',
            page: 1,
            total: 0,
            errorMsg: '',
            textError: false,
            breadCrumbList: [{ name: '關鍵字搜尋', link: '', ga: '' }],
            inputText: '',
            currentPage: 1,
            lastPage: 0,
            orderby: {
                value: 'src',
                label: '最相關',
            },
            type: {
                value: '',
                label: '全部',
            },
            display: 'card',
            orderbyList: [
                {
                    value: 'src',
                    label: '最相關',
                },
                {
                    value: 'viewCounts',
                    label: '最熱門',
                },
                {
                    value: 'desc',
                    label: '新到舊',
                },
                {
                    value: 'asc',
                    label: '舊到新',
                },
            ],
            typeList: [
                {
                    value: '',
                    label: '全部',
                },
                {
                    value: 'VIDEO',
                    label: '影片',
                },
                {
                    value: 'IMAGE',
                    label: '圖片',
                },
                {
                    value: 'ARTICLE',
                    label: '文章',
                },
                {
                    value: 'HTML',
                    label: '互動網頁',
                },
            ],
            articleRes: [],
            search: '',
        };
    },
    computed: {
        gaData() {
            return this.systemName + '|' + this.contentPage + '|';
        },
    },
    watch: {
        '$route.params.page': function() {
            this.currentPage = this.$route.params.page;
            this.getArticleList();
        },
        '$route.params.search': function() {
            this.search = this.$route.params.search;
            this.inputText = this.$route.params.search;
            this.getArticleList();
        },
    },
    created() {
        // this.inputText = this.$store.state.searchInputs.input;
        this.orderby = this.$store.state.searchInputs.orderby ? Object.assign(this.$store.state.searchInputs.orderby) : this.orderbyList[0];
        this.type = this.$store.state.searchInputs.type ? Object.assign(this.$store.state.searchInputs.type) : this.typeList[0];
        this.display = this.$store.state.displayArticles;
        this.currentPage = Number(this.$route.params.page);
        this.search = this.$route.params.search;
        this.inputText = this.$route.params.search;
        this.getArticleList = debounce(this.getData, 500);
        this.getArticleList();
    },
    methods: {
        setActionInputs(page) {
            this.getArticleList();
            this.routerTo(1, this.search);
            this.$router.push({ name: 'search', params: { page: page, search: this.$route.params.search } }).catch(() => { });
            this.$store.dispatch('setSearchInputs',
                { orderby: this.orderby, type: this.type });
        },
        inputValid() {
            if (!this.inputText && this.inputText !== '') {
                return;
            }
            const value = this.inputText;
            const reg = /[\u4e00-\u9fa5]{1}/g;
            const notReg = /[\w|\s|.|·]{1}/g;
            // const pattern = /[1234567890]/;
            const cn = value.match(reg) || [];
            const en = value.match(notReg) || [];
            // const number = value.match(pattern);
            this.textError = cn.length + en.length === value.length;
            this.errorMsg = this.textError ? '' : '請勿輸入特殊字元';
            return this.textError;
        },
        getData() {
            this.loading = true;
            const page = Number(this.currentPage);
            if (page < 1 || !page) {
                this.routerTo(1, this.search);
                return;
            }
            this.articleRes = [];
            this.total = 0;
            this.lastPage = 0;
            const searchText = {
                search: this.search,
                conditions: [
                    {
                        column: 'contentType',
                        value: this.type.value,
                        operator: 'eq',
                    },
                ],
                sortBy: [],
                sortDesc: [], // asc=false, desc=true
                page: page - 1,
                size: this.size,
            };
            const desc = this.orderby.value === 'desc';
            searchText.sortDesc.push(desc);
            if (this.orderby.value === 'desc' || this.orderby.value === 'asc') {
                searchText.sortBy.push('onDate');
            } else {
                if (this.orderby.value === 'viewCounts') {
                    searchText.sortDesc[0] = true;
                }
                searchText.sortBy.push(this.orderby.value);
            }
            post('/api/content/list/search', searchText)
                .then((res) => {
                    if (res.status === 200) {
                        this.currentPage = page;
                        const result = res.response;
                        if (result.contents.length > 0) {
                            this.articleRes = result.contents;
                            this.total = result.total;
                            this.lastPage = Math.ceil(this.total / result.size);
                            window.scrollTo(0, 0);
                        }
                    } else {
                        this.go404Page(res.status);
                    }
                })
                .catch((error) => {
                    this.go404Page(error.status);
                }).finally(() => {
                    this.loading = false;
                });
        },
        getInputText(text) {
            this.search = text;
            this.getArticleList();
            this.routerTo(1, this.search);
        },
        setOrderby(value) {
            this.orderby = Object.assign(value);
            this.setActionInputs(1);
        },
        setType(value) {
            this.type = Object.assign(value);
            this.setActionInputs(1);
        },
        setDisplay(type) {
            this.setDisplayArticles(type);
        },
        getPage(value) {
            this.routerTo(value, this.search);
        },
        routerTo(pg, text) {
            this.$router.push({ name: 'search', params: { page: pg, search: text } }).catch(() => { });
        },
    },
};
</script>
<style lang="scss" scoped>
.itemList {
    .lightcolor {
        color: #d5d5d5;
    }
}
.listType {
    position: absolute;
    top: -3.5rem;
    right: 0;
    @include media-breakpoint-up(md) {
        top: -3rem;
    }
    @include media-breakpoint-up(lg) {
        margin-top: 0;
        top: 0;
        position: relative;
    }
}
.moreItem__btn {
    position: relative;
    max-width: 24rem;
}
.btn__arraw {
    position: absolute;
    right: 0.75rem;
}
.searchBlock__content {
    width: 100%;
    .errorMsg {
        height: 1rem;
        font-size: 0.75rem;
        color: rgb(250, 61, 61);
        @include media-breakpoint-up(md) {
            height: 1.25rem;
            font-size: 0.875rem;
        }
    }
}
.search__input {
    width: calc(100% - 27%);
    display: inline-block;
    height: 50px;
    padding-left: 1rem;
    margin-right: 1%;
    border-color: $primary;
    @include media-breakpoint-up(sm) {
        width: calc(100% - 7.75rem);
        margin-right: 0.25rem;
    }
    @include media-breakpoint-up(md) {
        width: calc(100% - 8rem);
        margin-right: 0.5rem;
    }
}
.search__btn {
    width: 26%;
    height: 50px;
    letter-spacing: 3px;
    vertical-align: top;
    @include media-breakpoint-up(sm) {
        width: 7.5rem;
    }
    @include media-breakpoint-up(md) {
        width: 7.5rem;
    }
}
</style>
